<template>
  <div class='training-page'>
    <div class="background-container">
      <div class='background-wave-left'></div>
      <div class='background-wave-right'></div>
    </div>
    <div class="training-container">
      <div class='training-details'>
        <div class='training-title'>NOS FORMATIONS</div>
        <div class='training-underline'></div>
        <CategoriesTrainingComponent :trainings='trainings' :activeTrainingName='trainingName'></CategoriesTrainingComponent>
      </div>

      <div v-if="currentTraining" class="description-container" :class="{
          inverse: mode !== 'description'
        }">
        <div v-if="currentTraining.disabled" class="disable-title">Bientôt disponible</div>
        <transition name="fade" mode="out-in">
          <div :key="currentTraining.id" class="description-content" :class="{
            disable: currentTraining.disabled
          }">
            <DescriptionTrainingComponent :training="currentTraining" v-if="mode === 'description'"></DescriptionTrainingComponent>
            <ProgramTrainingComponent :training="currentTraining" v-else></ProgramTrainingComponent>
          </div>
        </transition>
      </div>

    </div>

  </div>
</template>

<script>
import CategoriesTrainingComponent from '@/components/training/CategoriesTrainingComponent'
import DescriptionTrainingComponent from '@/components/training/DescriptionTrainingComponent'
import ProgramTrainingComponent from '@/components/training/ProgramTrainingComponent'
import data from '@/data/fixtures'

export default {
  name: 'TrainingPage',
  props: ['trainingName', 'mode'],

  metaInfo: {
    title: "Shokunin, les formations de L'Atelier - VueJS, Web API, React, Azure... Découvrez nos formations",
    meta: [{
      vmid: 'description',
      name: 'description',
      content: "Les formations Shokunin portent sur le développement dans les technologies les plus plébiscitées du web : React, VueJS, .NET, etc... La formation Web API vous permettra de comprendre, d'utiliser et de concevoir une API en suivant les bonnes pratiques."
    }]
  },

  components: {
    CategoriesTrainingComponent,
    DescriptionTrainingComponent,
    ProgramTrainingComponent
  },
  data () {
    return {
      trainings: data.trainings
    }
  },
  computed: {
    currentTraining () {
      return this.trainings.find(training => training.name === this.trainingName)
    }
  },
  created () {
    window.document.title = "Shokunin, les formations de L'Atelier - VueJS, Web API, React, Azure... Découvrez nos formations"
  }

}
</script>

<style lang='scss' scoped>
.disable-title {
  position: ABSOLUTE;
  width: 100%;
  text-align: center;
  font-size: 38px;
  left: 0;
  top: 164px;
  // color: #b98a2f;
  opacity: 0.74;
  font-weight: 500;
  text-transform: capitalize;
}

.description-content.disable {
  filter: blur(7px);
  pointer-events: none;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .3s ease;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

.background-container {
  position: fixed;
  top: 0;
  height: 100%;

  height: 100vh;
  width: 100%;
  max-width: 1800px;

  margin: auto;

  @include media(phone) {
    display: none;
  }
}

.training-container {
  position: relative;

  display: flex;
  flex-direction: row;
  width: 100%;
  max-width: 1400px;
  padding-top: 76px;

  margin: 64px 16px;

  z-index: 10;

  @include media (tablet) {
    display: flex;
    flex-direction: column;
  }

  @include media(phone) {
    margin-top: 42px;
  }

}

.description-container {
  position: relative;
  z-index: 1;

  background-color: #FFFFFF;
  border: 4px solid #B98A30;
  border-radius: 5px;
  box-shadow: 0 2px 9px 0 rgba(124,124,124,0.5);

  width: 100%;

  &.inverse {
    background-color: #B98A30;
    border: 4px solid #FFFFFF;
  }

  max-width: 864px;

  box-sizing: border-box;

  margin-left: 424px;
  margin-top: 118px;

  @include media(tablet) {
    position: relative;
    top: 0;
    right: 0;

    width: unset;

    margin: 0 8px;
    margin-top: 20px;
  }
}

.training-details {
  height: 100%;

  width: 485px;

  position: fixed;
  overflow: hidden;

  @include media (tablet) {
    position: relative;
    width: 100%;
  }
}

.training-page {
  display: flex;
  justify-content: center;
  align-items: flex-start;

  flex-direction: row;

  min-height: 100vh;
  min-width: 100vw;

  background: #f1f1f1;

  .background-wave-left {
    background-image: url('../assets/vague10.png');
    background-repeat: no-repeat;
    background-position: bottom left;
    background-size: 40%;
    height: 100%;
    width: 100%;

    background-position-x: 150px;
    background-position-y: calc(100% + 250px);
  }

  .background-wave-right {
    position: absolute;
    background-image: url('../assets/vague10.png');
    background-repeat: no-repeat;
    background-size: 25%;

    top: 0;

    width: 100%;
    height: 100%;

    transform: scale(1.8);
    background-position-x: 78%;
    background-position-y: 238px;

  }

  .training-title {
    @extend %default-title;
    margin-bottom: 14px;

    @include media(phone) {
      margin-left: 8px;
    }
  }

  .training-underline {
    @extend %default-underline;

    @include media (tablet) {
      margin: 0 8px;
    }

    @include media (phone) {
      margin-bottom: 16px;
    }
  }
}
</style>
